export default __webpack_public_path__ + "static/nazar-kovtun-852510cbd2f88b6b9e3111e92ae81cb3.png";